module.exports = __webpack_public_path__ + "krecove-zily_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/krecove-zily_5_after_tn.jpg
// module id = 1501
// module chunks = 0